import api from '../utils/api';

const BUSINESS_ID = process.env.REACT_APP_BUSINESS_ID;

export const getLoyaltyProgress = () => {
  return api.get(`/businesses/${BUSINESS_ID}/loyalty/progress`);
};

export const getLoyaltyStamps = () => {
  return api.get(`/businesses/${BUSINESS_ID}/loyalty/stamps`);
};
